import * as React from 'react';
import { SvgProps } from '../SvgGetter/SvgGetter';
import { Colors } from '../../../../styles/colors';

export const Tøyning: React.FC<SvgProps> = ({
	fill = 'white',
	pathFill = Colors.primaryTekst,
	stroke = Colors.primaryTekst,
	...props
}) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='100%'
		height='100%'
		viewBox='0 0 15 14'
		fill='none'
		{...props}
	>
		<path
			d='M8.24849 3.49932C8.24849 3.08377 7.91418 2.74946 7.49863 2.74946C7.08309 2.74946 6.74878 3.08377 6.74878 3.49932V6.18942L5.78022 5.22086C5.48653 4.92716 5.01162 4.92716 4.72105 5.22086C4.43048 5.51455 4.42736 5.98946 4.72105 6.28002L6.97061 8.52958C7.2643 8.82328 7.73921 8.82328 8.02978 8.52958L10.2793 6.28002C10.573 5.98633 10.573 5.51142 10.2793 5.22086C9.98565 4.93029 9.51074 4.92716 9.22017 5.22086L8.25161 6.18942V3.49932H8.24849ZM1.24985 0C0.83431 0 0.5 0.334309 0.5 0.749853C0.5 1.1654 0.83431 1.49971 1.24985 1.49971L13.7474 1.49971C14.163 1.49971 14.4973 1.1654 14.4973 0.749853C14.4973 0.334309 14.163 0 13.7474 0L1.24985 0Z'
			fill={pathFill}
		/>
		<path
			d='M13.5 10H12.4162C12.0058 10 11.6054 10.1262 11.2692 10.3615L8.64692 12.1972C7.95828 12.6792 7.04172 12.6792 6.35308 12.1972L3.73077 10.3615C3.3946 10.1262 2.99419 10 2.58384 10H1.5'
			stroke={stroke}
			strokeWidth='1.3'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);
